export default "__VITE_ASSET__EG7mvq9T__"